import { Wallet, CalendarCheck, Users } from "lucide-react";

const defaultBenefits = [
  {
    Icon: Wallet,
    title: "You only pay when you earn",
    body: "From 12% + VAT, charged per booking. No setup fee, no monthly retainer, nothing on empty nights.",
  },
  {
    Icon: CalendarCheck,
    title: "Use it whenever you like",
    body: "Block any dates in your owner dashboard. A weekend, a month, every school holiday. No restriction, no charge.",
  },
  {
    Icon: Users,
    title: "One local team, not a call centre",
    body: "A dedicated point of contact on the ground in Manchester. Local contractors who can be at your door the same day.",
  },
];

export default function ManchesterKeyBenefits({ config }) {
  const cityName = config?.cityName || "Manchester";
  const benefits = defaultBenefits.map((b, i) =>
    i === 2 ? { ...b, body: `A dedicated point of contact on the ground in ${cityName}. Local contractors who can be at your door the same day.` } : b
  );
  return (
    <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(48px,6vw,72px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 48 }} className="kb-grid">
          {benefits.map(({ Icon, title, body }) => (
            <div key={title}>
              <div style={{ width: 44, height: 44, borderRadius: 10, background: "#E8F2E0", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 18 }}>
                <Icon size={20} color="#112215" strokeWidth={1.8} />
              </div>
              <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 18, color: "#112215", margin: "0 0 10px", letterSpacing: "-0.01em", lineHeight: 1.3 }}>{title}</h3>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14.5, color: "#5C7268", lineHeight: 1.6, margin: 0 }}>{body}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .kb-grid { grid-template-columns: 1fr !important; gap: 32px !important; } }
      `}</style>
    </section>
  );
}